import { Checkbox, FormControlLabel } from '@mui/material';
import { PaloDetailSlot } from '@synergy/components-palo';
import { ReactElement, ReactNode } from 'react';
import { getIn, useFormikContext } from 'formik';

export interface PaloSendOptionProps {
    /** Formik path of the flag. */
    name: string;
    label: ReactNode;
    /** Value when the form has none yet. */
    defaultValue?: boolean;
}

/**
 * Whether completing the document also sends it, as a checkbox beside the main
 * action. The decision is taken when completing, so it sits at that button
 * rather than in a row of the form (#2250, #2251).
 */
export const PaloSendOption = ({ name, label, defaultValue = false }: PaloSendOptionProps): ReactElement => {
    const formik = useFormikContext();

    return (
        <PaloDetailSlot name="beforeActions">
            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        checked={getIn(formik.values, name) ?? defaultValue}
                        onChange={(_, checked) => formik.setFieldValue(name, checked)}
                    />
                }
                label={label}
                sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: '12.5px' } }}
            />
        </PaloDetailSlot>
    );
};
